export const ENTITIES = '@@INSTRUCTION/ENTITIES';

export enum LIST {
  REQUEST = '@@INSTRUCTION/LIST/REQUEST',
  SUCCESS = '@@INSTRUCTION/LIST/SUCCESS',
  FAILURE = '@@INSTRUCTION/LIST/FAILURE'
}

export enum SINGLE {
  REQUEST = '@@INSTRUCTION/SINGLE/REQUEST',
  SUCCESS = '@@INSTRUCTION/SINGLE/SUCCESS',
  FAILURE = '@@INSTRUCTION/SINGLE/FAILURE'
}

export enum STATUS {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  SUSPENDED = 'SUSPENDED',
  EXPIRED = 'EXPIRED'
}

export const STORE_RESET = '@@STORE/RESET';
